/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  initialState: { currentUser?: API.CurrentUser } | undefined,
) {
  const { currentUser } = initialState ?? {};
  return {
    canAdmin: true, // 临时允许所有用户访问管理功能
    // canAdmin: currentUser && currentUser.access === 'admin', // 原始逻辑
  };
}
